export default __webpack_public_path__ + "static/selo-gptw 1-99700dab31867ca92ec1a6e5d0627e19.svg";